import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { SocialDistributionState } from '../types'
import { socials } from '@/config/socialDistribution'
import { Platform } from '@/types/platform'

const availableSocials: Getter<SocialDistributionState, RootState> = (
  state,
  getters,
  rootState
) => {
  return Object.keys(state.groups)
    .filter((socialCode) => {
      if (socialCode === 'viber' && rootState.platform === Platform.cosmo) {
        return false
      }

      return socialCode !== 'twitter'
    })
    .map((socialCode) => {
      // console.log('social', code)
      const social = socials[socialCode]

      return {
        text: social.title || socialCode,
        value: socialCode,
      }
    })
}

export default availableSocials
